import { FieldValues, useController, useFormContext } from 'react-hook-form';
import { FieldProps } from '../../../generic/FieldProps';
import { EmailInput } from './EmailInput';

export function EmailField<TValues extends FieldValues>({
  name,
  required = false,
}: FieldProps<TValues>) {
  const { control } = useFormContext<TValues>();
  const {
    field: { value, onChange },
  } = useController({
    name,
    control,
  });
  return (
    <EmailInput
      value={value as string}
      onChange={onChange}
      required={required}
    />
  );
}
